import { render } from "./ScaleTareModal.vue?vue&type=template&id=3c736fb3&ts=true"
import script from "./ScaleTareModal.vue?vue&type=script&lang=ts"
export * from "./ScaleTareModal.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ScaleTareModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c736fb3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c736fb3', __exports__)) {
    api.reload('3c736fb3', __exports__)
  }
  
  module.hot.accept("./ScaleTareModal.vue?vue&type=template&id=3c736fb3&ts=true", () => {
    api.rerender('3c736fb3', render)
  })

}


export default __exports__